import '../styles/pages/Forbidden.css';


const Forbidden = () => (
    <div className="forbidden">
        <h1>403 – Access Denied</h1>
        <p>You are not allowed to view this page.</p>
    </div>
);

export default Forbidden;